import { render, staticRenderFns } from "./save.vue?vue&type=template&id=f7cdaddc&scoped=true"
import script from "./save.vue?vue&type=script&lang=ts"
export * from "./save.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7cdaddc",
  null
  
)

export default component.exports